import styled from 'styled-components';

export const CodeDiv = styled.div`
  padding: 0px 12px;
`;
